import {mock} from './index';

export default {
  queryAuditLog: (): void => mock('/audit/log/query'),
  getFilterAuditList: (): void => mock('/audit/filter/list'),
  exportAuditLog: (): void => mock('/audit/log/export'),
  getLogDuration: (): void => mock('/audit/log/duration')
};
